const Label = ({
    variant = 'primary',
    children, 
    className = '' 
}) => {
    // const { isDark } = useTheme();
    
    const variantClasses = {
        primary: `text-[#121212] dark:text-[#D0D0D0]`,
        secondary: `text-[#7B7B7B] dark:text-[#848484]`,
    };

    return (
        <span className={`${variantClasses[variant]} ${className}`}>
            {children}
        </span>
    );
};

export default Label;